import React, { useEffect, useState } from 'react';
import Loader from '../../../../_common/Loader/Loader';
import classes from '../../dashboard.module.scss';
import Api from '../../../../../api/api';

const BARS = [
  { key: 'rxReceived', label: 'Rx received', color: '#3730A3' },
  { key: 'paApproved', label: 'PA approved', color: '#6366F1' },
  { key: 'therapyStarted', label: 'Therapy started', color: '#93C5FD' },
];

const STATS = [
  { key: 'paDenialRate', label: 'PA denial rate' },
  { key: 'startAbandonRate', label: 'Start abandon rate' },
];

const TimeToTherapyChart = ({ requestData }) => {
  const [timeToTherapyData, setTimeToTherapyData] = useState({});
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const response = await Api.getTimeToTherapyChart(requestData);

        setTimeToTherapyData(response.data || {});
        loadingToggle(false);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [requestData]);

  const isEmpty = BARS.every((b) => !(timeToTherapyData[b.key]?.count ?? 0));

  return (
    <div className={classes.chart_kpi_wrapper} style={{ padding: 16 }}>
      <p style={{
        margin: '0 0 4px', fontWeight: 700, fontSize: 15, color: '#111827',
      }}
      >
        Time to therapy
      </p>

      {loading
        ? <Loader className={classes.chart_kpi_wrapper_loader} />

        : isEmpty
          ? <div className={classes.chart_is_empty}>No data to display</div>

          : (
            <>
              <p style={{ margin: '0 0 16px', fontSize: 12, color: '#6B7280' }}>
                {`Avg ${timeToTherapyData.avgDays ?? 0} days · Rx received → therapy start`}
              </p>

              {BARS.map((bar, idx) => {
                const count = timeToTherapyData[bar.key]?.count ?? 0;
                const percent = timeToTherapyData[bar.key]?.percent ?? 0;
                return (
                  <div key={bar.key} style={{ marginBottom: 12 }}>
                    <p style={{ margin: '0 0 4px', fontSize: 12, color: '#6B7280' }}>{bar.label}</p>
                    <div
                      className={classes.ttt_bar}
                      style={{
                        position: 'relative',
                        height: 40,
                        borderRadius: 6,
                        background: bar.color,
                        width: `${Math.max(percent, 4)}%`,
                        minWidth: 80,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0 12px',
                        boxSizing: 'border-box',
                        animationDelay: `${idx * 0.15}s`,
                      }}
                    >
                      <span style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>{count}</span>
                      <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13 }}>{`${percent}%`}</span>
                    </div>
                  </div>
                );
              })}

              <div style={{ marginTop: 30, borderTop: '1px solid #F3F4F6', paddingTop: 12 }}>
                {STATS.map((stat) => (
                  <div
                    key={stat.key}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontSize: 13,
                      color: '#6B7280',
                      marginBottom: 4,
                    }}
                  >
                    <span>{stat.label}</span>

                    <span style={{ fontWeight: 700, color: '#111827' }}>
                      {`${timeToTherapyData[stat.key]?.percent ?? 0}%`}
                    </span>
                  </div>
                ))}
              </div>
            </>
          )}
    </div>
  );
};

export default TimeToTherapyChart;
